import { HardDrives } from '@phosphor-icons/react';
import React, { useState } from 'react';
import { Namespace } from '../../../../types/namespace';
import { DraggableItemShell } from '../dnd/DraggableItemShell';
import type { ReservedFolderType } from '../dnd/types';
import { ActionMenu } from './ActionMenu';
import { Item } from './Item';
import { useSidebarItemDraggable } from './useSidebarItemDraggable';

interface AgentVectorMemoryItemProps {
  namespace: Namespace;
  isNested?: boolean;
  spaceId?: string | null;
  parentId?: string | null;
  ancestorReservedType?: ReservedFolderType | null;
  onEdit: (ns: Namespace) => void;
  onDelete: (ns: Namespace) => void;
}

const AgentVectorMemoryItemComponent: React.FC<AgentVectorMemoryItemProps> = ({
  namespace,
  isNested = true,
  spaceId = null,
  parentId,
  ancestorReservedType = null,
  onEdit,
  onDelete,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const draggable = useSidebarItemDraggable({
    itemId: namespace.id,
    kind: 'vector',
    parentId: parentId ?? namespace.folderId ?? null,
    spaceId,
    label: namespace.name,
    ancestorReservedType,
  });

  return (
    <DraggableItemShell
      ref={draggable.setNodeRef}
      isDragging={draggable.isDragging}
      dropAbove={draggable.showDropAbove}
      dropBelow={draggable.showDropBelow}
    >
      <Item
        icon={<HardDrives size={16} />}
        label={namespace.name}
        isNested={isNested}
        onClick={() => onEdit(namespace)}
        onMenuClick={anchor => {
          setAnchorEl(anchor);
        }}
      />
      <ActionMenu
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        onEdit={() => {
          setAnchorEl(null);
          onEdit(namespace);
        }}
        onDelete={() => {
          setAnchorEl(null);
          onDelete(namespace);
        }}
        showEdit={true}
      />
    </DraggableItemShell>
  );
};

export const AgentVectorMemoryItem = React.memo(AgentVectorMemoryItemComponent);
